import React, { useEffect, useState } from 'react'
import { supabase } from '../lib/supabase'
import { clearTariffeCache } from '../lib/dataloader'

export default function AdminEirParametri() {
  const [par, setPar] = useState([])
  const [durate, setDurate] = useState([])
  const [editsPar, setEditsPar] = useState({})
  const [editsDur, setEditsDur] = useState({})
  const [newDur, setNewDur] = useState({ mesi: '', coefficiente: '' })
  const [loading, setLoading] = useState(true)

  useEffect(() => { load() }, [])
  async function load() {
    setLoading(true)
    const [p, d] = await Promise.all([
      supabase.from('eir_parametri').select('*').order('chiave'),
      supabase.from('eir_coeff_durata').select('*').order('mesi'),
    ])
    setPar(p.data || []); setDurate(d.data || [])
    setLoading(false)
  }

  async function saveParam(chiave) {
    const v = editsPar[chiave]; if (v === undefined) return
    await supabase.from('eir_parametri').update({ valore: parseFloat(v) }).eq('chiave', chiave)
    setEditsPar(s => { const x={...s}; delete x[chiave]; return x })
    clearTariffeCache(); load()
  }
  async function saveDurata(mesi) {
    const v = editsDur[mesi]; if (v === undefined) return
    await supabase.from('eir_coeff_durata').update({ coefficiente: parseFloat(v) }).eq('mesi', mesi)
    setEditsDur(s => { const x={...s}; delete x[mesi]; return x })
    clearTariffeCache(); load()
  }
  async function addDurata() {
    if (!newDur.mesi || !newDur.coefficiente) return
    await supabase.from('eir_coeff_durata').insert({ mesi: parseInt(newDur.mesi), coefficiente: parseFloat(newDur.coefficiente) })
    setNewDur({ mesi: '', coefficiente: '' })
    clearTariffeCache(); load()
  }
  async function delDurata(mesi) {
    if (!window.confirm(`Eliminare durata ${mesi} mesi?`)) return
    await supabase.from('eir_coeff_durata').delete().eq('mesi', mesi)
    clearTariffeCache(); load()
  }

  if (loading) return <div className="loading">Caricamento...</div>

  return (
    <div>
      <div className="page-header">
        <h1>Parametri EIR</h1>
        <p>Coefficienti globali della tariffa: tax, broker fee, moltiplicatori veicolo/satellitare.</p>
      </div>

      <div className="card">
        <h2 className="card-title">Parametri globali</h2>
        <table>
          <thead><tr><th>Chiave</th><th>Valore</th><th>Descrizione</th><th></th></tr></thead>
          <tbody>
            {par.map(p => {
              const v = editsPar[p.chiave] !== undefined ? editsPar[p.chiave] : p.valore
              const dirty = editsPar[p.chiave] !== undefined
              return (
                <tr key={p.chiave}>
                  <td><strong>{p.chiave}</strong></td>
                  <td><input type="number" step="0.0001" value={v}
                             onChange={e => setEditsPar(s => ({ ...s, [p.chiave]: e.target.value }))}
                             style={{ width: 120, background: dirty?'#FFF7E5':'transparent' }} /></td>
                  <td className="text-small text-muted">{p.descrizione}</td>
                  <td>{dirty && <button className="btn btn-sm btn-primary" onClick={() => saveParam(p.chiave)}>Salva</button>}</td>
                </tr>
              )
            })}
          </tbody>
        </table>
      </div>

      <div className="card mt-2">
        <h2 className="card-title">Coefficienti durata</h2>
        <p className="text-small text-muted" style={{ marginBottom: '1rem' }}>Moltiplicatore della tariffa al variare della durata della copertura.</p>
        <table>
          <thead><tr><th>Mesi</th><th>Coefficiente</th><th></th></tr></thead>
          <tbody>
            {durate.map(d => {
              const v = editsDur[d.mesi] !== undefined ? editsDur[d.mesi] : d.coefficiente
              const dirty = editsDur[d.mesi] !== undefined
              return (
                <tr key={d.mesi}>
                  <td><strong>{d.mesi} mesi</strong></td>
                  <td><input type="number" step="0.01" value={v}
                             onChange={e => setEditsDur(s => ({ ...s, [d.mesi]: e.target.value }))}
                             style={{ width: 100, background: dirty?'#FFF7E5':'transparent' }} /></td>
                  <td>
                    {dirty && <button className="btn btn-sm btn-primary" onClick={() => saveDurata(d.mesi)}>Salva</button>}
                    <button className="btn btn-sm btn-danger" style={{ marginLeft: 8 }} onClick={() => delDurata(d.mesi)}>×</button>
                  </td>
                </tr>
              )
            })}
            <tr>
              <td><input type="number" placeholder="mesi" value={newDur.mesi} onChange={e => setNewDur(s => ({...s, mesi: e.target.value}))} style={{ width: 80 }}/></td>
              <td><input type="number" step="0.01" placeholder="coeff" value={newDur.coefficiente} onChange={e => setNewDur(s => ({...s, coefficiente: e.target.value}))} style={{ width: 100 }}/></td>
              <td><button className="btn btn-sm btn-primary" onClick={addDurata}>+ Aggiungi</button></td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  )
}
